import { Map, List, Record } from "immutable";
import { AnyAction } from "redux";

import { ACTION_SUCCESS } from "@services/AsyncActionCreatorFactory";

import { FETCH_DATA_LAYER } from "./datalayer.actions";
import { DataLayerReducer, DataLayerDto } from "./datalayer.typings";

const dataLayerInitialState: DataLayerDto = {
  bookingMade: false,
  firstBooking: false,
  userId: "",
  lastBookingType: "",
  email: null,
  phoneNumber: null,
  firstName: "",
  lastName: "",
  address: {
    street: "",
    city: "",
    postalCode: "",
    countryCode: "",
    stateName: "",
  },
};

const initialState: Record<DataLayerReducer> = Record<DataLayerReducer>({
  lastUpdate: 0,
  data: List(),
})();

const datalayerReducer = (
  store: Record<DataLayerReducer> = initialState,
  action: AnyAction,
) => {
  const { payload, type } = action;

  switch (type) {
    case `${FETCH_DATA_LAYER}${ACTION_SUCCESS}`: {
      const { data }: { data: DataLayerDto } = payload;

      return store
        .set("lastUpdate", Date.now())
        .set(
          "data",
          store.get("data").push(Record(dataLayerInitialState)(data)),
        );
    }

    default: {
      return store;
    }
  }
};

export { datalayerReducer };
